
function selectTime() {
    $('.item').click(function(e) {
        var currentItem = document.querySelector(".active");;
        
        if(currentItem !==null){
            currentItem.classList.remove("active");
        }
        e.target.classList.add('active');
    });
}

function timeListOnPage() {
    if($('.js-time-items').is(':visible')) {
        selectTime();
    } else {
        setTimeout(timeListOnPage, 50);
    }
}

window.onload = timeListOnPage;
